import React, { ChangeEvent, Component } from "react";
import classnames from "classnames";
import { isValid } from "date-fns/esm";
import { observable } from "mobx";
import { observer } from "mobx-react";

import { InputElement } from "@formant/ui/component/common/Field";

import { appStore } from "../../stores";
import { formatDate } from "../../utils/formatDate";
import { formatDateString } from "../../utils/formatDateString";
import { fromUtc } from "../../utils/fromUtc";
import * as styles from "./TimeEdit.scss";

export interface ITimeEditProps {
    time: Date;
    onChangeTime: (time: Date) => void;
    className?: string;
    disabled?: boolean;
}

@observer
export class TimeEdit extends Component<ITimeEditProps> {
    @observable
    private value: string | undefined;

    public render() {
        const { value, onChange, onBlur } = this;
        const { className, disabled, time } = this.props;

        return (
            <input
                type="time"
                className={classnames(styles["time-edit"], className)}
                value={value || formatDateString(time, "HH:mm:ss")}
                step={1}
                required={true}
                onChange={onChange}
                onBlur={onBlur}
                disabled={disabled}
            />
        );
    }

    private onChange = (event: ChangeEvent<InputElement>) => {
        const { time, onChangeTime } = this.props;
        const { value } = event.target;
        this.value = value;
        let newTime = new Date(`${formatDate(time)} ${value}`);
        if (appStore.utc) {
            newTime = fromUtc(newTime);
        }
        if (isValid(newTime)) {
            onChangeTime(newTime);
        }
    };

    private onBlur = () => {
        this.value = undefined;
    };
}
